<ng-template let-page #ocrOverlay>
  @if (enableOverlay()) {
    <ct-extraction-ocr-overlay
      (contextmenu)="$event.preventDefault()"
      class="absolute top-0 left-0 h-full w-full"
      ctExtractionLassoSelection
      [isTableCreationToggled]="this.toolbarService.isTableCreationEnabled()"
      [page]="page"
      [(enableAutoUpdate)]="enableAutoUpdate"
      [isFieldExtractionOverlayCollapsed]="isFieldExtractionOverlayCollapsed()"
      [ensureSingleOverlay]="ensureSingleOverlay()"
      [selectedDocumentId]="selectedDocumentId()"
      (fieldExtractionOverlayToggle)="setIsFieldExtractionOverlayCollapsed($event)"
      #ocrOverlayComponent />
  }
</ng-template>
<ct-shared-document-preview
  #documentPreview
  [pageOverlayTemplate]="ocrOverlay"
  [isPreviewListExpandedInitially]="isPreviewListExpandedInitially()"
  (imageContainerScrollEnd)="enableAutoUpdate.set(false)"
  (documentSelected)="onDocumentSelected($event)"
  [documentClassFilterEnabled]="true"
  [ctBatch]="ctBatchStoreService.ctBatch"
  [allDocuments]="sortedDocuments()"
  [singleOpenedDocument]="isShowAllDocumentsEnabled() ? undefined : singleOpenedDocument()">
  <ct-shared-toolbar-button
    [additionalClasses]="isShowAllDocumentsEnabled() ? 'bg-[#E9F4F8]' : 'hover:bg-theme-gray-500'"
    [isActive]="isShowAllDocumentsEnabled()"
    (click)="toggleShowAllDocuments()"
    iconPath="assets/icons/page-stack"
    [pTooltip]="
      isShowAllDocumentsEnabled()
        ? 'Seiten der Forderungsaufstellung anzeigen'
        : 'Alle Dokumente anzeigen'
    "
    tooltipPosition="right" />
  @let isTableCreationToggled = toolbarService.isTableCreationEnabled();
  @if (isTableExtraction()) {
    <ct-shared-toolbar-button
      [disabled]="doUnconfirmedTablesExist()"
      [additionalClasses]="isTableCreationToggled ? 'bg-[#E9F4F8]' : 'hover:bg-theme-gray-500'"
      [isActive]="isTableCreationToggled"
      (click)="toggleTableCreation()"
      iconPath="assets/icons/table-creation"
      pTooltip="Tabelle erstellen"
      tooltipPosition="right" />
    <hr class="border-theme-gray-700 w-2/3" />
    <div class="flex grow flex-col items-center gap-y-2.5 pb-3">
      <ct-extraction-table-extraction-tool-hints class="mt-auto" />
    </div>
  }
</ct-shared-document-preview>
